import styled from 'styled-components';

import { scrollbar } from 'common/styles/scrollbar';

import FlexContainer from 'common/components/atoms/FlexContainer';
import Label from 'common/typography/Label/Label';

export const ProgressTrack = styled.div`
  width: 100%;
  height: 8px;
  border-radius: 999px;
  background: ${props => props.theme.colors.greyXL};
  overflow: hidden;
`;

export const ProgressFill = styled.div`
  height: 100%;
  width: ${props => `${props.progress}%`};
  transition: width 250ms ease;
  background: ${props => props.theme.primaryColor};
`;

export const ProgressContainer = styled(FlexContainer)`
  margin-top: 10px;
  border: 1px solid ${props => props.theme.colors.greyXL};
  border-radius: 6px;
  max-height: 220px;
  overflow-y: auto;
  ${scrollbar}
`;

export const ProgressRow = styled(FlexContainer)`
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 8px 10px;
  border-bottom: 1px solid ${props => props.theme.colors.greyXL};
  &:last-child {
    border-bottom: none;
  }
`;

export const StatusBadge = styled.span`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  text-transform: capitalize;
  background: ${props => props.backgroundColor};
  color: ${props => props.color};
`;

export const OverallProgressContainer = styled(FlexContainer)`
  margin-top: 8px;
  margin-bottom: 8px;
`;

export const ProgressName = styled(Label)`
  margin: 0;
  font-size: 13px;
  font-weight: 600;
`;

export const ProgressValue = styled(Label)`
  margin: 0;
  font-size: 12px;
  color: ${props => props.theme.colors.greyXD};
`;
